var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('img',_vm._g({staticClass:"ma-1",attrs:{"width":"24","src":_vm.src}},on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.skill))])])}
var staticRenderFns = []

export { render, staticRenderFns }